export const storeIdSessionStorageKey = 'kodyorder-store-id';
